import * as React from "react"
import { Container } from "react-bootstrap"

import Layout from "../../components/layout"
import Seo from "../../components/seo"
import Table from "../../components/Table"

import useHinduTemplesData from "../../hooks/useHinduTemplesData.js"

const HinduTemplesPage = ({location}) => {
	const columns = [
		{ name: "English Name", key: "english_name_I" },
		{ name: "Tamil Name", key: "chinese_name_I" },
		{ name: "Address", key: "full_address" },
	]

	const data = useHinduTemplesData()

	return (
		<Layout location={location}>
			<Seo title="Index of Hindu Temples" />

			<Container>
				<h1>Hindu Temples</h1>

				<Table
					columns={columns}
					data={data}
					paginationSize={50}
					routeLink={() => "/map"}
					routeState={({ id }) => ({ id })}
				/>

			</Container>

		</Layout>
	)
}

export default HinduTemplesPage
